import { render } from "./PanelsLayout.vue?vue&type=template&id=496f7c97&scoped=true&ts=true"
import script from "./PanelsLayout.vue?vue&type=script&lang=ts"
export * from "./PanelsLayout.vue?vue&type=script&lang=ts"

import "./PanelsLayout.vue?vue&type=style&index=0&id=496f7c97&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-496f7c97"]])

export default __exports__